import React from 'react';
import { styled } from '@linaria/react';
import { Icon, COLORS } from '@livecommerce/design-system';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CircleWrapper = styled.div`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;

const ProgressCircle = styled.circle`
  transition: stroke-dashoffset 0.35s;
  transform: rotate(0deg);
  transform-origin: center;
`;

const CheckmarkCircle = styled.div`
  position: relative;
  border-radius: 50%;
  border: ${(props) => `2px solid ${props.color}`};
  color: ${(props) => props.color};
  height: 100%;
`;

const StyledCheckmarkIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const SIZES = {
  MEDIUM: 'medium',
  LARGE: 'large',
};

const VALUES_BY_SIZE = {
  [SIZES.MEDIUM]: {
    radius: 14,
    strokeWidth: 4,
  },
  [SIZES.LARGE]: {
    radius: 21,
    strokeWidth: 6,
  },
};

const Progress = ({
  progress,
  size = SIZES.LARGE,
  checkmarkColor = '#0FBB0C',
  circleColor = COLORS.light_400,
  progressColor = '#0FBB0C',
}) => {
  const radius = VALUES_BY_SIZE[size].radius;
  const circumference = 2 * Math.PI * radius;
  const validProgress = Math.min(Math.max(progress * 100, 0), 100);
  const offset = circumference - (validProgress / 100) * circumference;

  const width = VALUES_BY_SIZE[size].radius * 2 + VALUES_BY_SIZE[size].strokeWidth;
  const height = VALUES_BY_SIZE[size].radius * 2 + VALUES_BY_SIZE[size].strokeWidth;
  return (
    <Container>
      <CircleWrapper width={width} height={height}>
        {validProgress !== 100 && (
          <svg width={width} height={height} style={{ transform: 'rotate(-90deg)' }}>
            <circle
              cx={width / 2}
              cy={height / 2}
              r={radius}
              stroke={circleColor}
              strokeWidth={VALUES_BY_SIZE[size].strokeWidth}
              fill="none"
            />
            <ProgressCircle
              cx={width / 2}
              cy={height / 2}
              r={radius}
              stroke={progressColor}
              strokeWidth={VALUES_BY_SIZE[size].strokeWidth}
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
            />
          </svg>
        )}

        {validProgress === 100 && (
          <CheckmarkCircle color={checkmarkColor}>
            <StyledCheckmarkIcon name="checkmark" width={width - 4} height={height - 4} />
          </CheckmarkCircle>
        )}
      </CircleWrapper>
    </Container>
  );
};

export default Progress;
